export const differenceChoices = [
  { value: true, label: "有り" },
  { value: false, label: "無し" },
];
